var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#535C79",
    d: "M16.157 4.874C16.5 6.21 16.5 9 16.5 9s0 2.79-.343 4.127c-.19.738-.748 1.32-1.453 1.516C13.422 15 9 15 9 15s-4.42 0-5.704-.357a2.11 2.11 0 0 1-1.453-1.517C1.5 11.79 1.5 9 1.5 9s0-2.79.343-4.126c.19-.74.748-1.32 1.453-1.517C4.58 3 9 3 9 3s4.422 0 5.704.357c.708.2 1.265.78 1.453 1.516M7.5 11.625 12 9 7.5 6.375z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgYoutube;